import { render, staticRenderFns } from "./justificativaFaltaPortalAluno.vue?vue&type=template&id=0449faf6"
import script from "./justificativaFaltaPortalAluno.vue?vue&type=script&lang=js"
export * from "./justificativaFaltaPortalAluno.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports